<template>
    <section v-if="hasPermissions(['Assignment-Project-Template Complete'])" class="view fix-space__button">
        <div class="row mb-0 assignments">
            <div class="col-12 duties pt-0">
               <Breadcrumb :breadcrumb="breadcrumb"/>

                <h1 class="view__title title--1" v-html="`Complete Project - ${title_page}`"/>

                <div class="view__description">
                    <p class="view__description__text">
                        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Pariatur dolorem cumque possimus nobis ut iure architecto, assumenda iste cupiditate libero sed debitis magni deleniti enim corporis veniam et aut. Et.
                    </p>
                </div>

                <div class="row mb-0">
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="Associate:" class="modal-label" v-html="`Associate:`"/>
                            <select class="input-field custom-select" v-model="associate_id" disabled>
                                <option value="" v-html="'Select an option'"/>
                                <option v-for="(item, i) in array_options.associate_id" :key="i" :value="item.id" v-html="item.associate_name"/>
                            </select>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="Associate:" class="modal-label" v-html="`Last Completed:`"/>
                            <input type="date" v-model="last_completed"/>
                        </div>
                    </div>
                    <div class="col-md-auto flex-xl-grow-1">
                        <div class="modal__buttons text-center text-md-left" style="margin-top:35px;">
                            <span class="custom-control custom-checkbox">
                                <input :id="'hideCompletedTasks'" type="checkbox" class="custom-control-input" v-model="check_completed_task" />
                                <label :for="'hideCompletedTasks'" class="custom-control-label ml-2" v-html="'Hide completed tasks'"/>
                            </span>
                        </div>
                    </div>

                    
                    <div class="col-md-auto flex-xl-grow-1" v-if="hasPermissions(['Assignment-Project-Template Read'])">
                        <div class="modal__buttons text-center text-md-left text-lg-right" style="margin-top:35px;">
                            <div class="btn-group modal__buttons__item">
                                <button type="button" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; padding-right:15px;" v-html="'Export'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"/>
                                <button type="button" class="dropdown-toggle dropdown-toggle-split ml-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; padding-right:0px;">
                                    <span class="sr-only"/>
                                </button>
                                <div class="dropdown-menu" :style="'font-size: 14px; padding:0; margin-top: 0px;'">
                                    <a class="dropdown-item" href="#" v-html="'Export to PDF Portrait'" @click="confirmationReportModal('portrait')"/>
                                    <a class="dropdown-item" href="#" v-html="'Export to PDF Landscape'" @click="confirmationReportModal('landscape')"/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-auto flex-xl-grow-1">
                        <div class="modal__buttons text-center text-md-left text-lg-center" style="margin-top:15px;">
                            <button class="modal__buttons__item" v-html="`Complete project`" style="margin-top:20px; float:right;" @click="project_complete()"/>
                        </div>
                    </div>
                    
                </div>

                <div class="row mb-0" v-if="rooms.length" style="margin-top:20px;">
                    <div class="col-md-12">
                        <div class="table-responsive">
                            <table class="table">
                                <thead style="background-color: transparent;">
                                    <tr>
                                        <th style="padding-top:25px;" scope="col" v-for="(item, i) in room_table_headers" :key="i" v-html="item.name"/>
                                        <th style="padding-top:25px;" v-if="single_object.show_minutes" scope="col" v-html="`Scheduled Minutes`"/>
                                        <th style="padding-top:25px;" scope="col" v-html="`Actual Minutes`"/>
                                        <th style="padding-top:25px;" scope="col">
                                        Complete 
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`completed_checkall`" type="checkbox" class="custom-control-input" @change="checkAll()" :checked="isCheckAll" />
                                                <label :for="`completed_checkall`" class="custom-control-label ml-2"/>
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in display_rooms" :key="i">
                                        <td v-html="item.description"/>
                                        <td v-html="item.frequency"/>
                                        <td v-html="item.room_type"/>
                                        <td v-html="item.task_name"/>

                                        <!-- Special Column -->
                                        <td>
                                            <input type="date" v-model="item.last_completed"/>
                                        </td>
                                        <td v-if="single_object.show_minutes" v-html="item.daily_minutes"/>
                                        <td>
                                            <span>
                                                <input 
                                                    :id="`input${i}`"
                                                    type="number"
                                                    :min="1" :max="1000"
                                                    class="form-control"
                                                    v-model="item.actual_minutes"
                                                    :placeholder="'Actual minutes'"
                                                    style="color:black;"
                                                />
                                            </span>
                                        </td>
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`completed${i}`" type="checkbox" class="custom-control-input" v-model="item.completed" />
                                                <label :for="`completed${i}`" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <WaitingModal/>

        <SupervisorReportModal 
            title="Confirmation Modal"
            :rest_api="rest_api"
            :breadcrumb="breadcrumb"
            @running_submit="running_submit($event)"
        />

        <ConfirmationModal
            :message="'Project completion submitted successfully.'"
            :second_message="' Would you like to return to the main projects screen?'"
            @ConfirmEmition="back_to_project()"
        />

        <LastCompleteFormModal 
            :title="'Set Last Complete Date'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :single_body_object="single_body_object"
            :body_index="body_index"
            :notyf="notyf"
            :array_options="array_options"
            @CompletedReplacing="manualSetLastCompleteDate($event)"
        />

    </section>
</template>

<script>

import Breadcrumb             from  '@/components/BreadcrumbComponent/Breadcrumb.vue'
import FormResources          from  './form_resources'
import Resources              from  './resources'
import WaitingModal           from  '@/components/WaitingModal'
import ConfirmationModal      from  '@/components/ConfirmationModal.vue'
import LastCompleteFormModal  from  './LastCompleteFormModal/LastCompleteFormModal'
import SupervisorReportModal from './SupervisorReportModal.vue'
import { Notyf }              from  'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
})

export default {
    name: 'ProjectRoomComplete',

    components: {
        Breadcrumb,
        WaitingModal,
        ConfirmationModal,
        LastCompleteFormModal,
        SupervisorReportModal
    },
    
    data(){
        return{
            notyf,
            parent_id:              this.$route.params.id,
            user:                   this.get_user(),
            rest_api:               `projects/${this.$route.params.id}`,
            lite_rest_api:          `projects`,
            rest_api_note:          `project_notes`,
            self_rest_api:          'projects-rooms-complete',
            form_format:            FormResources.form_format,
            breadcrumb:             Resources.breadcrumb,
            title_page:             '',
            content_header:         this.$store.state.headers,
            single_object:          {},
            check_completed_task:   false,

            array_options:      {
                show_minutes: Resources.standard_options,
                associate_id: []
            },

            rooms:                  [],
            single_body_object:     {},
            body_index:             null,
            room_table_headers:     Resources.room_complete_table_headers,
            select_all:             false,
            show_scheduled_minutes: true,
            associate_id:           '',
            current_date:           '',
            project_work_page_id:   '',
            display_current_date:   this.currentDateToString(),
            json_pdf_fields:        [],
            report_name:            '',
            format:                 '',
            today:                  new Date(),
            last_completed: '',
        }
    },

    methods:{

        checkAll()
        {
            const ids = this.display_rooms.map(room => room.id);
            const rooms = this.rooms.filter(room => ids.includes(room.id));

            const check_all = !this.isCheckAll

            rooms.forEach(room => {
                room.completed = check_all
            })
        },

        last_complete_form_modal(index)
        {
            this.body_index = index
            this.single_body_object = {...this.display_rooms[index]}
            window.$('#static-last-complete').modal('show')
        },

        async manualSetLastCompleteDate(event)
        {
            let current_index = event.index 
            let current_room = event.room

            if(parseFloat(current_room.actual_minutes) < 1 || parseFloat(current_room.actual_minutes) > 20000)
            {
                notyf.error('Invalid values for Actual minutes setted')
                return false
            }

            let item_running = {
                id: current_room.id,
                last_completed: current_room.last_completed,
                actual_minutes: current_room.actual_minutes !== '' ? parseFloat(current_room.actual_minutes) : null,
                completed:  current_room.completed,
                associate_id: this.single_object.associate_id,
                single: true,
            }

            this.loader(true)

            let response = await this.post(this.self_rest_api, item_running)

            if(response.status)
            {
                let item_completed = response.data.completed
                this.display_rooms.splice(current_index, 1, item_completed)
                notyf.success('Success')
                this.loader()
            }
            else
            {
                this.error_handling(response)
            }
        },

        async project_complete()
        {
            let rooms_selected = this.display_rooms

            let validation = rooms_selected.filter(item => parseFloat(item.actual_minutes) < 0 || parseFloat(item.actual_minutes) > 2000)

            if(validation.length)
            {
                notyf.error('Invalid values for Actual minutes setted')
                return false
            }

            let rooms_mapped = rooms_selected.map((item) => {
                return {
                    id: item.id,
                    last_completed: item.last_completed ? item.last_completed : this.current_date,
                    actual_minutes: item.actual_minutes ? parseFloat(item.actual_minutes) : item.annual_minutes,
                    completed:  item.completed,
                    associate_id: this.single_object.associate_id
                }
            })

            this.loader(true)

            let response = await this.post(this.self_rest_api, rooms_mapped)

            if(response.status)
            {
                let completed = response.data.completed

                if(completed.length)
                {
                    this.rooms.map(item => item['new'] = false)

                    completed.forEach((item) => 
                    {
                        let finding_index = this.rooms.findIndex(prop => prop.id === item.id)

                        if(finding_index > -1)
                        {
                            this.rooms.splice(finding_index, 1, item)
                        }
                    })
                }
                setTimeout(() => {
                    window.$('#confirmation-modal').modal('show')
                }, 500)
            }
            else
            {
                this.error_handling(response)
            }


            this.loader()


        },

        back_to_project()
        {
            window.location.href = !this.has_role('Employee') ? `/assignment-project/${this.parent_id}` : '/assignment-projects'
        },

        fill_data(data)
        {
            this.current_date = data.current_date
            
            let data_rooms = data.rooms

            data_rooms.map((item) => {
                item['new'] = true
            })

            this.rooms = data_rooms

            this.single_object = data.project

            this.associate_id = this.single_object.associate_id

            this.title_page = this.single_object.description

            this.breadcrumb[2].arrow = "<span class='slash'>/</span>"

            if(this.hasPermissions(['Assignment-Project-Template Read']))
            {
                this.breadcrumb.push({
                    name:   this.single_object.description,
                    href:   `/assignment-project/${this.parent_id}`,
                    arrow:  "<span class='slash'>/</span>",
                })
            }
            else
            {
                this.breadcrumb.splice(1)
            }

            this.breadcrumb.push(
                {
                    name:   `Complete Project - ${this.single_object.description}`,
                    href:   `/assignment-project-comnplete/${this.parent_id}`,
                    arrow:  " ",
                }
            )

            // this.array_options.associate_id = data.associates
            this.array_options.associate_id = data.associates.filter(item => item.id === this.associate_id)
            const associate = data.associates.find(item => item.id === this.associate_id)
            this.rooms.forEach((item) => {
                item.complete = '[_]'
            })
            this.room_table_headers.forEach((item) => {
                this.json_pdf_fields.push({
                    title: item.name,
                    dataKey: item.id,
                })
            })
            if(this.single_object.show_minutes)
            {
                this.json_pdf_fields.push({
                    title: 'Scheduled Minutes', 
                    dataKey: 'daily_minutes',
                });
            }
            this.json_pdf_fields.push({
                title: 'Complete',
                dataKey: 'complete',
            });
            this.report_name = `Complete Project - ${ associate ? associate.name : 'Default' }`;
        },

        selectAll()
        {
            if(this.rooms.length)
            {
                this.rooms.map(item => {
                    item.checked = this.select_all
                })
            }
        },

        addWaterMark(doc)
        {
            const total_pages = doc.internal.getNumberOfPages()

            for (let i = 1; i <= total_pages; i++)
            {
                doc.setPage(i)
                doc.addImage("/assets/img/logo.png", 'png', 40, 40, 120, 40)
                doc.text(this.report_name, 180, 130)
                doc.text(this.today.toDateString(), 450, 70)
                doc.setTextColor(150)
                doc.text(40, doc.internal.pageSize.height - 30, this.report_name)
                doc.text(510, doc.internal.pageSize.height - 30, `${i} of ${total_pages}`)
            }

            return doc
        },

        confirmationReportModal(format)
        {
            this.format = format

            window.$('#static-supervisor-modal').modal('show')
        },

        running_submit(report_version)
        {   
            let url = `/standard-reports/projects/project-assignment?id=${this.single_object.decrypted_id}&supervisor_copy=${report_version.supervisor_report}&format=${this.format}`

            window.open(url, '_blank');
        },

    },

    computed:
    {
        display_rooms()
        {
            return this.check_completed_task ? this.rooms.filter( item => item.last_completed !== '' && item.next_scheduled !== '' ? this.current_date > item.last_completed && this.current_date < item.next_scheduled : item ) : this.rooms
        },
        
        selected()
        {
            let bool = this.rooms.filter(item => item.new || item.completed && item.new)
            return Boolean(bool.length)
        },

        isCheckAll()
        {
            const boolean = this.display_rooms.every(room => room.completed);
            return boolean;
        }
    },

    watch: {
        async 'last_completed' (val)
        {
            this.display_rooms.forEach(room => {
                room.last_completed = val
            })
        }
    },

    async mounted(){
        if(this.hasPermissions(['Assignment-Project-Template Complete']))
        {
            await this.api_request(this.rest_api)
        }
        else
        {
            window.location = '/'
        }
    },
}
</script>